export default function getEssentialLocationData(locations) {
  if (!locations || !Array.isArray(locations)) return [];
  if (locations.length > 1) {
    return locations.map((loc) => ({ level: loc.level, hkey: loc.hkey }));
  }
  return locations; 
}